import React, { useContext } from "react";
import { FaHardHat, FaGlasses, FaHeadphones, FaHandsHelping } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import "../TrainingGlobal.css";
import BannerImage from "./ppe.jpg";

const PPE: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/ppe');
    } else {
      navigate('/login', { state: { from: '/booking/ppe' } });
    }
  };

  return (
    <div className="training-page">
      <div className="training-max-width">

        {/* --- HERO --- */}
        <div className="training-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Personal Protection</span>
          <h1 className="hero-title">Personal Protective Equipment (PPE)</h1>
          <p className="hero-subtitle">
            The last line of defense against workplace hazards.
            Understanding selection, usage, and maintenance of your safety gear.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">The Hierarchy of Controls</h2>
              <p className="article-text">
                PPE is the least effective method of hazard control because it relies on human behavior
                and does not remove the hazard itself. It should only be used when Elimination,
                Substitution, Engineering, and Administrative controls are not feasible or sufficient.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Head to Toe Protection</h2>
              <p className="article-text">
                Different hazards require specialized gear:
                <ul style={{ paddingLeft: '20px', color: '#ccc', marginTop: '10px', lineHeight: '1.8' }}>
                  <li><strong>Head:</strong> Hard hats for falling objects and electrical shocks.</li>
                  <li><strong>Eyes:</strong> Safety glasses/goggles for dust, chemical splashes, or radiation.</li>
                  <li><strong>Ears:</strong> Earplugs/muffs for noise levels above 85dB.</li>
                  <li><strong>Respiratory:</strong> N95, half-face, or SCBA for toxic atmospheres.</li>
                  <li><strong>Hands:</strong> Gloves protecting against cuts, chemicals, or heat.</li>
                  <li><strong>Feet:</strong> Steel-toe boots for crushing hazards and slips.</li>
                </ul>
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Proper Fit & Maintenance</h2>
              <p className="article-text">
                PPE that doesn't fit is PPE that won't work. Loose gloves can get caught in machinery;
                poorly sealed respirators leak toxins. Regular inspection is mandatory—cracked helmets,
                torn gloves, or scratched lenses must be replaced immediately.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Standard Gear</h4>
              <ul className="key-list">
                <li><FaHardHat className="check-icon" /> Safety Helmet</li>
                <li><FaGlasses className="check-icon" /> Impact Goggles</li>
                <li><FaHeadphones className="check-icon" /> Hearing Protection</li>
                <li><FaHandsHelping className="check-icon" /> Cut-Resistant Gloves</li>
              </ul>
            </div>

            <div className="sidebar-widget">
              <h4 className="widget-title">The Golden Rule</h4>
              <p style={{ color: '#aaa', lineHeight: '1.6', fontSize: '0.9rem' }}>
                Inspect it before you wear it. If in doubt, throw it out. Your life depends on it.
              </p>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Safety Gear Training</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Learn how to properly select and maintain your PPE.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default PPE;
